import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const EventsList = Loadable(
  // lazy(() => import("features/events/components/List"))
  lazy(() => import("features/event_New/components_1/List"))
);
const EventPage = Loadable(
  // lazy(() => import("features/events/components/Page"))
  lazy(() => import("features/event_New/components_1/Page"))
);
const EventUpload = Loadable(
  // lazy(() => import("features/events/components/UploadPage"))
  lazy(() => import("features/event_New/components_1/UploadPage"))
);
const EventDocument = Loadable(
  // lazy(() => import("features/events/components/UploadDocument"))
  lazy(() => import("features/event_New/components_1/UploadDocument"))
);
const FeeCollection = Loadable(
  lazy(() =>
    import("features/event_New/components_1/EventRegistration/FeeCollectionList")
  )
);

const routes = {
  path: "events",
  children: [
    { path: "", element: <EventsList /> },
    { path: "add", element: <EventPage /> },
    { path: "edit/:eventID?", element: <EventPage /> },
    { path: "upload", element: <EventUpload /> },
    { path: "uploaddocument", element: <EventDocument /> },
    {
      path: "feeCollection",
      element: <FeeCollection />,
      handle: {
        hideBreadcrumbs: true,
      },
    },
  ],
};

export default routes;
